<nav class="navBar shadow-sm  row bgGray6 py-2 d-flex align-items-center">
    <div class="logo col-lg-2  d-flex justify-content-center">
        <img  width="120" src="assets/Icones/EEYAA_logo2A.png" alt="" srcset="">
    </div>
    <div class="search col-lg-6 ">
        <div class="border searchBar row d-flex  align-items-center rounded">
            <input class="rounded-left h-100 form-control" type="text" placeholder="Rechercher talent, cleint et autre...">
            <button class=" bgGray6 ">
                <img  width="15" src="assets/Icones/Search1.png" alt="" srcset="">
            </button>
        </div>
    </div>
    <div class="userInfo col-lg-4  d-flex align-items-center justify-content-between">
        <img  width="45" src="assets/Icones/Chat1.png" alt="" srcset="">
        <div class="profilImg mx-3 rounded-circle d-flex justify-content-center align-items-center">
            <img *ngIf="profilType === 'talent'" class="rounded-circle"  src="assets/images/Image1.jpg" alt="" srcset="">
            <img *ngIf="profilType === 'entrepise'" class="rounded-circle"  src="assets/Icones/EEYAA_logo1A.png" alt="" srcset="">
        </div>
        <div *ngIf="profilType === 'talent'" class="info">
            <h6>Bienvenue, <span class="color1 text-nowrap">Jean-Mark KONAN</span></h6>
            <div style="font-size: 12px; ">Compte Talent <span style="margin-left: 10px; cursor: pointer;" (click)="logOut()">déconnexion</span></div>
        </div>
        <div *ngIf="profilType === 'entrepise'" class="info">
            <h6>Bienvenue, <span class="color1 text-nowrap">Non Entreprise</span></h6>
            <div style="font-size: 12px;">Compte Entreprise <span style="margin-left: 10px; cursor: pointer;" (click)="logOut()">déconnexion</span></div>
        </div>
    </div> 
</nav>
<div class="headerbottom bgGray6">
</div>
